"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BULK_REVIEW_PRODUCT_ATTRIBUTES = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.BULK_REVIEW_PRODUCT_ATTRIBUTES = (0, gql_1.gql)(`
  mutation ProductAttributesBulkReview($input: ProductAttributesBulkReviewInput!) {
    productAttributesBulkReview(input: $input) {
      success
      error
      affectedCount
    }
  }
`);
